import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Typography } from "@mui/material";

import { CheckmarkContainedIcon } from "assets";
import { COLORS } from "components";
import { JOBS_PAGE } from "pages/authenticated/jobs/consts";

interface SuccessStateProps {
  isPreview: boolean;
}

export const SuccessState = ({ isPreview }: SuccessStateProps) => (
  <Box sx={{ textAlign: "center" }}>
    <CheckmarkContainedIcon width={50} height={50} />
    <Typography
      sx={{
        fontSize: "16px",
        fontWeight: 700,
        color: COLORS.Mainblue,
        mb: 1,
        mt: 1.75,
      }}
    >
      {isPreview ? "Preview Recalculation Started" : "Recalculation Started"}
    </Typography>
    <Typography
      sx={{
        fontSize: "12px",
        color: "#4a6060",
        lineHeight: 1.7,
        maxWidth: "360px",
        margin: "0 auto",
      }}
    >
      {isPreview
        ? "A preview report will be sent to your email once the process is complete."
        : "Bills are being processed in the background."}{" "}
      You can track progress in the{" "}
      <RouterLink
        to={JOBS_PAGE.ABSOLUTE_PATH}
        target="_blank"
        style={{ color: COLORS.Mainblue, fontWeight: 500 }}
      >
        Jobs page
      </RouterLink>
      .
    </Typography>
  </Box>
);
